import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../components/Loader";
import { FaCircleUser } from "react-icons/fa6";
import Title from "../components/Title";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../slice/tokenSlice";
import pic from "../assets/images/user-icon.jpg";
import newlogo from "../assets/images/newlogo.webp";

const Journal = () => {
  const dispatch = useDispatch();
  const { url, user } = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  //
  const getJournal = async () => {
    try {
      const token = await dispatch(getToken());
      setLoading(true);
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${user.id}/SML_Portal`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        }
      );
      if (res.status === 200) {
        const data = res.data.data;

        data.forEach((item) => {
          Object.keys(item).forEach((key) => {
            item[key] = item[key] ?? "";
            //
            if (key === "Created_Time") {
              const date = new Date(item[key]);
              const formattedTime = date.toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              });
              item[key] = formattedTime;
            } else if (key === "Last_Activity_Time") {
              const date = new Date(item[key]);
              const formattedTime = date.toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              });
              item[key] = formattedTime;
            }
            //
            item.reply = "";
          });
        });
        //
        const filtered = data.filter((item) => {
          return item.Agent_Comments !== "" && item.Client_Comments !== "";
        });
        setData(filtered);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (user !== null) {
      getJournal();
    }
  }, [user]);
  return (
    <div>
      <Title title={"Journal"} />
      {loading === true ? (
        <Loader />
      ) : (
        <>
          {data.length === 0 ? (
            <p className="text-center">No data found</p>
          ) : (
            <>
              {data.map((item, index) => {
                return (
                  <div key={index}>
                    <hr />
                    <div className="text-center text-muted mb-2">
                      <small className="fw-bold text-black border border-primary p-2 rounded ">
                        {item.Title}
                      </small>
                    </div>
                    <div className="convo-flex">
                      <div className="convo-user-pic">
                        <img src={newlogo} alt="" />
                      </div>
                      <div>
                        <p className="mb-2">Settle My Loan</p>
                        <div className="convo-box">
                          <p>{item.Agent_Comments}</p>
                          <div className="text-end">
                            <small className="text-muted">
                              {item.Created_Time}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="convo-flex our-message">
                      <div className="convo-user-pic">
                        <img src={pic} alt="" />
                      </div>
                      <div>
                        <p className="text-end mb-2">{user.First_Name}</p>
                        <div className="convo-box">
                          <p>{item.Client_Comments}</p>
                          <div className="text-end">
                            <small className="text-muted">
                              {item.Last_Activity_Time}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Journal;
